export default __webpack_public_path__ + "media/rafaelVid.8fd97939.mp4";